/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Not_LinkedInputs */



/**
* | output |
* | --- |
* | "Not linked" |
*
* @param {Profile_Not_LinkedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_not_linked = /** @type {((inputs?: Profile_Not_LinkedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Not_LinkedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non lié")
	if (locale === "es") return /** @type {LocalizedString} */ ("No vinculado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não vinculado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non collegato")
	return /** @type {LocalizedString} */ ("Not linked")
});